module.exports = __webpack_public_path__ + "images/txffcc.ef21.png";